import { // SET_INSURANCE_CARRIER_RESPONSES,
  SET_FILTER_COVERAGE,
  SET_FILTER_COMPANY,
  SET_FILTER_PREMIUM_START,
  SET_FILTER_PREMIUM_END,
  SET_FILTER_SORT_BY,
  RESET_FILTERS,
  RESET_COMPARATION_QUOTATIONS,

  SET_SELECTED_PACKAGES,

  COMPARATION_PAGE_INITIALIZE_EXPECTED_PACKAGE_RESPONSES,
  COMPARATION_PAGE_ADD_PACKAGE_RESPONSE,
  COMPARATION_PAGE_INITIALIZE_INSURANCE_CARRIERS_RESPONSES,
  COMPARATION_PAGE_SET_PETITION_ALIVE,
} from 'Redux/types/comparationQuotationTypes';
import { QUOTATION_INSURANCE_CARRIER_STATE } from '@shared/constants/quotationInsuranceCarrierStates';

const isPackageQuotationStateLoading = (packageQuotationState) =>
  packageQuotationState === QUOTATION_INSURANCE_CARRIER_STATE.PENDING ||
  packageQuotationState === QUOTATION_INSURANCE_CARRIER_STATE.STARTED;

const syncInsuranceCarrierQuotationState = (entry, stateFromPackage) => {
  if (!stateFromPackage) return;

  if (isPackageQuotationStateLoading(stateFromPackage)) {
    entry.packageQuotationState = stateFromPackage;
    return;
  }

  if (!isPackageQuotationStateLoading(entry.packageQuotationState)) {
    entry.packageQuotationState = stateFromPackage;
  }
};

const initialState = {
  selectedPackages: [],
  filters: {
    selectedInsuranceCarriers: [],
    selectedCoverage: [],
    premiumStart: null,
    premiumEnd: null,
    sortBy: 'insuranceCarrier_asc',
  },

  // Se guardan las respuestas, también en qué porcentaje va y todo eso :)
  quotationPetitionAlive: false, // Determina si las peticiones para cotizar se siguien haciendo
  insuranceCarriersResponses: {},
};

const initializeEmptyInsuranceCarrierResponse = (insuranceCarrier) => ({
  insurance_carrier: insuranceCarrier.id,
  /*
  insurance_carrier_name: insuranceCarrier.name,
  responses_packages: [],
  errors: [],
  alerts: [],
  */
  percent_progress: 0,
  packageQuotationState: QUOTATION_INSURANCE_CARRIER_STATE.PENDING,
});

const initializeInsuranceCarrierResponses = (insuranceCarriers) => {
  if (!insuranceCarriers?.length) return {};

  return insuranceCarriers.reduce((insuranceCarriersResponses, insuranceCarrier) => {
    insuranceCarriersResponses[insuranceCarrier.id] = initializeEmptyInsuranceCarrierResponse(insuranceCarrier);
    return insuranceCarriersResponses;
  }, {});
};

const comparationQuotationReducer = (state = initialState, actions) => {
  switch (actions.type) {
    case SET_FILTER_COVERAGE:
      if (!state.filters.selectedCoverage.includes(actions.idCoverage)) {
        return {
          ...state,
          filters: {
            ...state.filters,
            selectedCoverage: [...state.filters.selectedCoverage, actions.idCoverage],
          },
        };
      }
      return {
        ...state,
        filters: {
          ...state.filters,
          selectedCoverage: state.filters.selectedCoverage.filter((id) => id !== actions.idCoverage),
        },
      };

    case SET_FILTER_COMPANY:
      if (!state.filters.selectedInsuranceCarriers.includes(actions.idCompany)) {
        return {
          ...state,
          filters: {
            ...state.filters,
            selectedInsuranceCarriers: [...state.filters.selectedInsuranceCarriers, actions.idCompany],
          },
        };
      }
      return {
        ...state,
        filters: {
          ...state.filters,
          selectedInsuranceCarriers: state.filters.selectedInsuranceCarriers.filter((id) => id !== actions.idCompany),
        },
      };

    case SET_FILTER_PREMIUM_START:
      return {
        ...state,
        filters: {
          ...state.filters,
          premiumStart: actions.premiumStart,
        },
      };

    case SET_FILTER_PREMIUM_END:
      return {
        ...state,
        filters: {
          ...state.filters,
          premiumEnd: actions.premiumEnd,
        },
      };

    case SET_FILTER_SORT_BY:
      return {
        ...state,
        filters: {
          ...state.filters,
          sortBy: actions.sortBy,
        },
      };

    case RESET_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters, // Mantiene el sortBy actual
          selectedInsuranceCarriers: [],
          selectedCoverage: [],
          premiumStart: null,
          premiumEnd: null,
        },
      };

    case RESET_COMPARATION_QUOTATIONS:
      return {
        ...initialState,
        // insuranceCarriersResponses: initializeInsuranceCarrierResponses(actions.aseguradoras),
      };

    case SET_SELECTED_PACKAGES:
      return {
        ...state,
        selectedPackages: actions.selectedPackages,
      }

    case COMPARATION_PAGE_INITIALIZE_EXPECTED_PACKAGE_RESPONSES:
      return {
        ...state,
        insuranceCarriersResponses: {
          ...state.insuranceCarriersResponses,
          ...initializeInsuranceCarrierResponses(actions.insuranceCarriers), // Inicializa las respuestas de las aseguradoras a cotizar
        },
      };

    case COMPARATION_PAGE_ADD_PACKAGE_RESPONSE:
      const insuranceCarriersResponsesCopy = { ...state.insuranceCarriersResponses};

      /*
      if (actions.packageResponse.status) {
        insuranceCarriersResponsesCopy[actions.packageResponse.insurance_carrier].responses_packages.push(actions.packageResponse);
      } else if (actions.packageResponse.alerts) {
        const { alerts } = actions.packageResponse
        insuranceCarriersResponsesCopy[actions.packageResponse.insurance_carrier].alerts.push(...alerts);
      } else if (actions.packageResponse.errors) {
        const { errors } = actions.packageResponse
        insuranceCarriersResponsesCopy[actions.packageResponse.insurance_carrier].errors.push(...errors);
      }
      */

      insuranceCarriersResponsesCopy[actions.packageResponse.insurance_carrier].percent_progress += actions.packageResponse.progress_value;

      const insuranceCarrierId = actions.packageResponse.insurance_carrier;
      const entry = insuranceCarriersResponsesCopy[insuranceCarrierId];
      if (entry) {
        const stateFromPackage = actions.packageResponse.package?.state;
        if (stateFromPackage) {
          syncInsuranceCarrierQuotationState(entry, stateFromPackage);
        } else if (actions.packageResponse.errors && !actions.packageResponse.status) {
          entry.packageQuotationState = QUOTATION_INSURANCE_CARRIER_STATE.FAILED;
        }
      }

      return {
        ...state,
        insuranceCarriersResponses: insuranceCarriersResponsesCopy,
      }
    
    /*
     Rehidrata insuranceCarriersResponses al abrir una cotización terminada.
     Solo se usa packageQuotationState y quotationPetitionAlive (loaders); paquetes y notificaciones vienen de storePackageAction.
     */
    case COMPARATION_PAGE_INITIALIZE_INSURANCE_CARRIERS_RESPONSES:
      const insuranceCarriersResponses = {}

      // Inicializa la estructura base para la respuesta de una aseguradora en insuranceCarriersResponses si aún no está presente
      const initializeInsuranceCarrierResponseIfMissing = (insuranceCarrierId) => { 
        if (!insuranceCarriersResponses[insuranceCarrierId]) {
          // Busca los detalles de la aseguradora correspondiente
          const insuranceCarrierDetails = actions.insuranceCarriers.find(insuranceCarrier => insuranceCarrier.id === insuranceCarrierId);

          insuranceCarriersResponses[insuranceCarrierId] = initializeEmptyInsuranceCarrierResponse({
            id: insuranceCarrierId,
            name: insuranceCarrierDetails.name || 'Sin nombre',
          });

          // Se establece el progreso al 100% porque es una solicitud completa que no espera respuesta del servidor
          insuranceCarriersResponses[insuranceCarrierId].percent_progress = 100;
          insuranceCarriersResponses[insuranceCarrierId].packageQuotationState = QUOTATION_INSURANCE_CARRIER_STATE.SUCCEEDED;
        }
      };

      const packagesByInsuranceCarrier = {};

      actions.fullQuotation.insurance_carrier_quotations.forEach((individualQuotation) => {
        const insuranceCarrierId = individualQuotation.insurance_carrier;

        initializeInsuranceCarrierResponseIfMissing(insuranceCarrierId);

        if (!packagesByInsuranceCarrier[insuranceCarrierId]) packagesByInsuranceCarrier[insuranceCarrierId] = [];
        packagesByInsuranceCarrier[insuranceCarrierId].push(individualQuotation);
      });

      Object.entries(packagesByInsuranceCarrier).forEach(([insuranceCarrierId, insurancePackages]) => {
        const loadingPackage = insurancePackages.find((insurancePackage) => (
          isPackageQuotationStateLoading(insurancePackage.state)
        ));
        if (loadingPackage) {
          insuranceCarriersResponses[insuranceCarrierId].packageQuotationState = loadingPackage.state;
          return;
        }

        const lastPackageWithState = [...insurancePackages].reverse().find(
          (insurancePackage) => insurancePackage.state != null,
        );
        if (lastPackageWithState) {
          insuranceCarriersResponses[insuranceCarrierId].packageQuotationState = lastPackageWithState.state;
        }
      });

      const quotationPetitionAliveAfterInit = actions.fullQuotation.insurance_carrier_quotations?.some(
        (insurancePackage) => isPackageQuotationStateLoading(insurancePackage.state),
      ) ?? false;

      return {
        ...state,
        insuranceCarriersResponses,
        quotationPetitionAlive: quotationPetitionAliveAfterInit,
      };

    case COMPARATION_PAGE_SET_PETITION_ALIVE:
      return {
        ...state,
        quotationPetitionAlive: actions.isAlive,
      };

    default:
      return state;
  }
};

export default comparationQuotationReducer;
